<!-- 
 * @description: 手机号码登陆模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-14 17:13:09
!-->
<template>
  <div
    class="phone"
    :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mphone' : 'phone'"
  >
    <div
      class="back"
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mback' : 'back'"
      @click="childPhone"
    ></div>
    <div class="title">{{ $t("message.navigator_mobile_logout") }}</div>

    <div class="inputBox">
      <div class="input-style">
        <span class="areaCode" @click="showSelectArea">
          {{ areaNum ? areaNum : $t("message.selectAreaCode") }}
        </span>
        <ul class="areaList" v-if="isAreaList">
          <li
            v-for="item in langDataList"
            :key="item.index"
            @click="langChange(item.area_code, item.mobile_length_input_tip)"
          >
            <span>{{ item.name }}</span
            ><em>{{ item.area_code }}</em>
          </li>
        </ul>
        <input
          type="text"
          :placeholder="
            mobileLengthTip ? mobileLengthTip : $t('message.input_mobile')
          "
          class="phone"
          v-model.trim="page1.phone"
          @click="focusEnd('phone')"
          id="phone"
        />
      </div>
      <div class="input-style">
        <input
          type="text"
          :placeholder="$t('message.enter_code')"
          class="phoneCode"
          v-model.trim="page1.code"
          @click="focusEnd('code')"
          id="code"
        />
        <p :class="['input-oper', { active: !canGetCode }]" @click="getCode">
          {{ codeTip }}
        </p>
      </div>
    </div>
    <p class="login-slogan">{{ $t("message.tips_1") }}</p>
    <!-- 勾选协议 -->
    <div class="type" @click="agreeduser">
      <div :class="['checked', { active: page1.isActive_u }]">
        <div class="icon">&radic;</div>
      </div>
      <p>{{ $t("message.agree") }}</p>
      <!-- <div class="agreementBtn"> -->
      <i class="agreementI" @click="gooperating"
        >{{ $t("message.rules_clause") }}、</i
      >
      <i class="agreementI" @click="goprivacy">{{
        $t("message.privacy_clause")
      }}</i>
      <!-- </div> -->
    </div>

    <!-- <p class="login-tip">{{ tip }}</p> -->
    <!--登录-->
    <div
      :class="['form-btn', { active: signIn }]"
      @click="page1.isdoLogin && doLogin()"
    >
      {{ $t("message.navigator_lang") }}
    </div>

    <!-- or 横线 -->
    <div class="Or"></div>

    <!-- 第三方登陆 -->
    <ul class="thirdPart" v-if="system === 'PC'">
      <li class="facebook" @click="webDotChildLogin('click_pcldy_facebook')">
        <img src="./../../assets/icon_fb.png" alt="" class="i-icon" />
        <span class="i-text">Facebook</span>
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
      <li>
        <img src="./../../assets/icon_google.png" alt="" class="i-icon" />
        <span class="i-text">Google</span>
        <div
          class="g_id_signin GoogleLogin"
          id="g_id_signin"
          @click="webDotChildLogin('click_pcldy_google')"
        ></div>
      </li>
    </ul>
    <ul class="thirdPart" v-if="system === 'MOBILE'">
      <li class="facebook" @click="webDotChildLogin('click_moldy_facebook')">
        <img src="./../../assets/icon_fb.png" alt="" class="i-icon" />
        <span class="i-text">Facebook</span>
        <fb-signin-button
          class="facebookLogin"
          :params="fbSignInParams"
          @success="FacebookonSuccess"
          @error="FacebookonFailure"
        ></fb-signin-button>
      </li>
      <li>
        <img src="./../../assets/icon_google.png" alt="" class="i-icon" />
        <span class="i-text">Google</span>
        <div
          class="g_id_signin GoogleLogin"
          id="g_id_signin"
          @click="webDotChildLogin('click_pcldy_google')"
        ></div>
      </li>
    </ul>
    <!-- 图形验证码 -->
    <div class="verificationCodeBox" v-if="isVerificationCodeBox">
      <div class="verificationCode">
        <div class="codeTitle">
          <i class="h-back" @click="GraphicalVerificaBack()"></i>
          <p>{{ $t("message.security_verification") }}</p>
        </div>
        <div class="codeContent">
          <div class="refreshCodeBtn" @click="GraphicalVerificaRefresh()"></div>
          <div class="CodeImg">
            <img :src="graphicalVerificaImg" alt="" />
          </div>
          <div class="codeResult">
            <input
              class="code-input"
              type="verificationCode"
              v-model="graphicalVerificaAnswer"
              :placeholder="$t('message.inputTheAnswer')"
            />
            <div
              class="btnResult"
              :class="{ activeCss: graphicalVerificaAnswer }"
              @click="graphicalVerificaAnswer.length > 0 && getCaptchaVerify()"
            >
              {{ $t("message.confirm") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图形验证 end -->
    <!-- 内容end -->
  </div>
</template>

<script>
import Vue from "vue";
import FBSignInButton from "vue-facebook-signin-button";
Vue.use(FBSignInButton);
import { RSSign } from "../../utils/sign.js";
import { Base64 } from "js-base64";

export default {
  name: "RastarPhone",
  props: ["appId", "pId", "mdId", "ukey", "system", "getCodeShow"],
  data() {
    return {
      // GoogleParams: {
      //   client_id:
      //     "864612029967-lg671faj52nat87vh7d6tscsashcfcbr.apps.googleusercontent.com",
      // },
      fbSignInParams: {
        scope: "email,user_likes",
        return_scopes: true,
      },
      page1: {
        phone: "",
        code: "",
        // 协议确认框
        isActive_u: false,
        // 是否可以登陆
        isdoLogin: false,
      },
      // 手机号码长度提示
      mobileLengthTip: "",
      // 是否显示地区全部列表
      isAreaList: false,
      // 地区全部列表
      langDataList: [],
      // 区地名字
      areaName: "",
      // 选择地区区号
      areaNum: "",

      codeTip: this.$t("message.get_code"),
      canGetCode: true,
      signIn: false,
      tip: "",

      // 是否显示图形验证码
      isVerificationCodeBox: false,
      operating: "",
      privacy: "",
      operating_url: "",
      privacy_url: "",
      // 圖形驗證碼圖片
      graphicalVerificaImg: "",
      // 圖形驗證碼答案
      graphicalVerificaAnswer: "",
      captchaKey: "",
      apiUrl: JSON.parse(this.$Storage.localStorageGet("api")),
      kfApi: JSON.parse(this.$Storage.localStorageGet("kfApi")),
    };
  },
  computed: {
    GoogleParams: function () {
      let client_id =
        "864612029967-lg671faj52nat87vh7d6tscsashcfcbr.apps.googleusercontent.com";
      if (this.appId == "103321") {
        client_id =
          "759807831783-g7ri4jm7deir5al9h0i0fcjfcqq92nni.apps.googleusercontent.com";
      } else if (this.appId == "104293") {
        client_id =
          "78655690810-bttulpd6i6jrf6eqj8p6h6v3hqr44n2d.apps.googleusercontent.com";
      }
      return {
        client_id,
        scope: "email",
      };
    },
  },
  methods: {
    sendCodeShow() {
      this.getCodeShow(false);
    },
    /*
     *@description: 触发埋点上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:16
     */
    webDotChildLogin(nodeVal) {
      this.$Report.webDotFather(this.pId, this.appId, this.ukey, nodeVal);
    },
    /*
     *@description: 接口错误上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    webErrorlogChild(errorMsg, action) {
      this.$Report.webErrorlogFather(
        this.pId,
        this.appId,
        this.ukey,
        errorMsg,
        action
      );
    },
    childPhone() {
      this.$emit("phoneB", false);
    },
    focusEnd(id) {
      let inpEl = document.getElementById(id);
      inpEl.focus();
      let length = inpEl.value.length;
      if (document.selection) {
        let range = inpEl.createTextRange();
        range.moveStart("character", length);
        range.collapse();
        range.select();
      } else if (
        typeof inpEl.selectionStart === "number" &&
        typeof inpEl.selectionEnd === "number"
      ) {
        // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length;
      }
    },
    // 显示下拉框
    showSelectArea: function () {
      this.isAreaList = true;
    },
    /*
     *@description: 點擊獲取地區
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    langChange: function (value, tips) {
      window._hmt.push([
        "_trackEvent",
        "手机号注册/登录选中区号",
        "点击",
        "click_phonenumber_m_areacode",
      ]);
      this.areaNum = value;
      this.mobileLengthTip = tips;
      this.isAreaList = false;
    },
    /*
     *@description: 获取手机区号
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getPhoneAreaCode() {
      let data = {
        tm: new Date().getTime(),
        cch_id: this.pId,
        app_id: this.appId,
        md_id: this.mdId,
        sys_language: this.$Storage.localStorageGet("lang"),
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
        area_code: this.areaNum,
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .login(this.apiUrl.user.get_mobile_area_code, data)
        .then((res) => {
          if (res.code == 200) {
            this.langDataList = res.data.area_code_country_data;
            this.areaNum = res.data.default_area_code;
            this.mobileLengthTip = res.data.default_mobile_length_input_tip;
          } else {
            this.tip = res.data.msg.replace(/\[.*?\]/g, "");
          }
        })
        .catch((err) => {
          this.webErrorlogChild(err.msg, "手机登陆接口");
        });
    },
    /*
     *@description: 手机号码格式校验接口 在请求图形验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getMobileFormatVerify(token) {
      let uinfoData = {
        area_code: this.areaNum,
        mobile: this.page1.phone,
      };
      let data = {
        tm: Date.parse(new Date()),
        token: token,
        cch_id: this.pId,
        app_id: this.appId,
        md_id: this.mdId,
        scene_type: "login",
        sdk_ver: this.$Base.sdkVer(),
        time_zone: this.$Base.timeZone(),
        sys_language: this.$Storage.localStorageGet("lang"),
        nonce: this.$Base.nonce(12),
        version: this.$Base.getVersion(),
        // area_code: this.areaNum,
        // mobile: this.page1.phone,
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .getMobileFormatVerify(this.apiUrl.user.mobile_format_verify, data)
        .then((res) => {
          if (res.code == 200) {
            this.getCaptchaToken();
          } else {
            this.canGetCode = true;
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.webErrorlogChild(err.msg, "手机号码格式校验接口");
        });
    },

    /*
     *@description: 获取验证码之前判断
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getCode: function () {
      if (!this.canGetCode) return;

      let phone = this.page1.phone;

      if (phone.length <= 0) {
        this.$toast(this.$t("message.input_mobile"));
        return;
      }

      if (this.areaNum.length <= 0) {
        this.$toast(this.$t("message.noneSelectArea"));
        return;
      }
      this.canGetCode = false;

      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            this.getMobileFormatVerify(res.data);
          }
        });
    },

    /*
     *@description: 圖形驗證碼刷新
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    GraphicalVerificaRefresh: function () {
      this.getCaptchaToken();
    },
    /*
     *@description: 圖形驗證碼关闭
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    GraphicalVerificaBack: function () {
      this.isVerificationCodeBox = false;
      this.graphicalVerificaAnswer = "";
      this.canGetCode = true;
    },
    /*
     *@description: 获取通用token，再获取图形验证码token
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getCaptchaToken() {
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            let data = {
              cch_id: this.pId,
              app_id: this.appId,
              device_id: window.localStorage.getItem("deviceIdUa"),
              sdk_ver: this.$Base.sdkVer(),
              sys_language: this.$Storage.localStorageGet("lang"),
              md_id: this.mdId,
              action: "sms_login",
              os: "wap",
              time_zone: this.$Base.timeZone(),
              version: this.$Base.getVersion(),
              tm: Date.parse(new Date()),
              nonce: this.$Base.nonce(12),
              token: res.data,
              capt_type: 2,
              uinfo: this.page1.phone,
            };
            data.sign = RSSign(data, data.app_id);
            this.$SyModel
              .getCaptchaToken(this.apiUrl.captcha.capt_token, data)
              .then((res) => {
                if (res.code == 200) {
                  this.getCaptchaInit(res.data);
                } else {
                  this.$toast(res.msg);
                }
              });
          }
        });
    },
    /*
     *@description: 图形验证码初始化
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getCaptchaInit(tokenData) {
      console.log("tokenData==", tokenData);
      this.captchaKey = tokenData.capt_token;
      console.log("captchaKey===", this.captchaKey);
      if (tokenData.vcaptcha == 1) {
        // 1 開始請求完之後讓二維碼顯示出來
        let data = {
          tm: Date.parse(new Date()),
          capt_type: 2,
          version: this.$Base.getVersion(),
          sys_language: window.localStorage.getItem("lang"),
          os: "wap",
          device_id: window.localStorage.getItem("deviceIdUa"),
          capt_token: this.captchaKey,
          time_zone: this.$Base.timeZone(),
          action: "sms_login",
          nonce: this.$Base.nonce(12),
          cch_id: this.pId,
          app_id: this.appId,
          // md_id: this.mdId,
        };
        data.sign = RSSign(data, data.app_id);
        this.$SyModel
          .getCaptchaInit(this.apiUrl.captcha.capt_init, data)
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              // 拿到图片地址填充到页面上
              this.graphicalVerificaImg = res.data.graph.graph_image;
              this.isVerificationCodeBox = true;
            } else {
              this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            }
          })
          .catch((err) => {
            this.webErrorlogChild(err.msg, "图形验证码初始化");
          });
      }
    },
    /*
     *@description: 圖形碼驗證校验
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getCaptchaVerify() {
      let ciphertextData = {
        entry_data: this.graphicalVerificaAnswer,
      };
      let ciphertext = Base64.encode(JSON.stringify(ciphertextData));
      let version3 = {
        ciphertext: ciphertext,
        version: this.$Base.getVersion(),
        nonce: this.$Base.nonce(12),
        associated_data: "",
      };
      version3.sign = RSSign(version3, this.appId);
      let data = {
        tm: Date.parse(new Date()),
        capt_type: 2,
        version: this.$Base.getVersion(),
        sys_language: window.localStorage.getItem("lang"),
        device_id: window.localStorage.getItem("deviceIdUa"),
        capt_token: this.captchaKey,
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        cch_id: this.pId,
        app_id: this.appId,
        encrypted_data: Base64.encode(JSON.stringify(version3)),
        action: "sms_login",
        os: "wap",
      };
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .getCaptchaVerify(this.apiUrl.captcha.capt_verify, data)
        .then((res) => {
          if (res.code == 200) {
            // 圖形驗證碼成功動作 一進來就要執行嗎??
            // 驗證成功關閉圖形框
            this.isVerificationCodeBox = false;
            this.graphicalVerificaAnswer = "";
            this.getPhoneCode();
            this.canGetCode = true;
          } else {
            this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            this.getCaptchaInit();
            this.canGetCode = true;
          }
        });
    },
    /*
     *@description: 获取手机验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getPhoneCode() {
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            this.getPhoneCodeData(res.data);
          }
        });
    },
    /*
     *@description: 封装获取手机验证码
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getPhoneCodeData(token) {
      let uinfoData = {
        area_code: this.areaNum,
        mobile: this.page1.phone,
      };
      let data = {
        tm: Date.parse(new Date()),
        token: token,
        cch_id: this.pId,
        app_id: this.appId,
        md_id: this.mdId,
        device_id: window.localStorage.getItem("deviceIdUa"),
        // uinfo: uinfoData,
        scene_type: "login",
        sdk_ver: this.$Base.sdkVer(),
        time_zone: this.$Base.timeZone(),
        sys_language: window.localStorage.getItem("lang"),
        nonce: this.$Base.nonce(12),
        version: this.$Base.getVersion(),
        capt_token: this.captchaKey,
      };
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .getMobileSendCode(this.apiUrl.user.mobile_send, data)
        .then((res) => {
          if (res.code === 200) {
            this.calculateSeconds();
          } else {
            this.canGetCode = true;
            this.$toast(res.msg.replace(/\[.*?\]/g, ""));
          }
        });
    },

    /*
     *@description: 短信验证码倒计时
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    calculateSeconds() {
      this.canGetCode = false;
      let seconds = 60;
      const interval = setInterval(() => {
        // this.codeTip = seconds + this.$t("m.reGetCode");
        this.codeTip = seconds + "s";
        seconds--;
        if (seconds < 0) {
          clearInterval(interval);
          this.codeTip = this.$t("message.get_code");
          this.canGetCode = true;
        }
      }, 1000);
    },

    /*
     *@description: 跳轉運營條款
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    gooperating: function () {
      window.open(this.kfApi.treaty.user_protocol, "_blank");
    },
    /*
     *@description: 跳轉隱私條款
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    goprivacy: function () {
      window.open(this.kfApi.treaty.private_protocol, "_blank");
    },

    /*
     *@description: 用户协议确认框
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    agreeduser() {
      if (this.page1.isActive_u) this.page1.isActive_u = false;
      else this.page1.isActive_u = true;
    },

    isEmpty1: function () {
      let quhao = this.areaNum;
      console.log(quhao);
      let phone = this.page1.phone;
      let code = this.page1.code;
      if (
        quhao !== this.$t("message.selectAreaCode") &&
        phone.length > 0 &&
        code.length > 0 &&
        this.page1.isActive_u
      ) {
        this.page1.isdoLogin = true;
        this.signIn = true;
      } else {
        this.page1.isdoLogin = false;
        this.signIn = false;
      }
    },

    /*
     *@description: 手机短信验证码校验接口接口
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    smsCheck(token) {
      let uinfoData = {
        area_code: this.areaNum,
        mobile: this.page1.phone,
      };
      let data = {
        tm: Date.parse(new Date()),
        token: token,
        cch_id: this.pId,
        app_id: this.appId,
        md_id: this.mdId,
        device_id: window.localStorage.getItem("deviceIdUa"),
        scene_type: "login",
        vcode: this.page1.code,
        sdk_ver: this.$Base.sdkVer(),
        time_zone: this.$Base.timeZone(),
        sys_language: window.localStorage.getItem("lang"),
        nonce: this.$Base.nonce(12),
        version: this.$Base.getVersion(),
      };
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .getMobileCheckCode(this.apiUrl.user.mobile_sms_check, data)
        .then((res) => {
          if (res.code === 200) {
            // 校验成功执行登陆步骤
            // deviceIdUa 存在
            this.$generalMethod
              .freezetoken(this.pId, this.appId, this.mdId)
              .then((res) => {
                if (res.code == 200) {
                  let uinfoData = {
                    mobile: this.page1.phone,
                    vcode: this.page1.code,
                    bind_type: 8,
                    area_code: this.areaNum,
                  };
                  this.loginSubmit(res.data, "Mobile", uinfoData);
                }
              });
          } else {
            this.$toast(res.msg.replace(/\[.*?\]/g, ""));
          }
        });
    },

    /*
     *@description: 请求通用token，拿到后执行手机短信验证码校验接口接口
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    getMobileCheckCode() {
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            this.smsCheck(res.data);
          }
        });
    },
    /*
     *@description: 點擊登錄
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    doLogin() {
      this.getMobileCheckCode();
    },
    /*
     *@description: 請求登錄接口
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    loginSubmit(token, ltype, uinfoData) {
      let _this = this;
      let data = {
        ts: new Date().getTime(),
        cch_id: _this.pId,
        app_id: _this.appId,
        md_id: _this.mdId,
        sys_language: this.$Storage.localStorageGet("lang"),
        token: token,
        ltype: ltype,
        time_zone: this.$Base.timeZone(),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
      };
      data.device_id = this.$Storage.localStorageGet("deviceIdUa");
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      this.$SyModel
        .login(this.apiUrl.user.normal_login, data)
        .then((res) => {
          if (res.code == 200) {
            _this.$emit("loginSuccess", res);
            // _this.emailBindShow = res.data.email_bind_show;
            // this.$Storage.localStorageSet("show", _this.emailBindShow);
            this.$Storage.localStorageSet("apiUname", _this.username);
            this.$Storage.localStorageSet("apiPwd", _this.password);
            // this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
            // this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
            // this.$Storage.localStorageSet(
            //   "access_token",
            //   res.data.access_token
            // );
            // // 登陆成功埋点
            // if (this.system === "PC") {
            //   _this.webDotChildLogin("login_pcldy_password_success");
            // } else {
            //   _this.webDotChildLogin("login_moldy_password_success");
            // }
            // // 登陆成功了跳转页面
            // window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            _this.$toast(errorMsg);
            _this.getImage();
          }
        })
        .catch((err) => {
          this.$toast(err.replace(/\[.*?\]/g, ""));
          this.webErrorlogChild(err.msg, "手机号login接口");
        });
    },
    /*
     *@description: FB登录 https://blog.csdn.net/qq_42386231/article/details/120063148?utm_medium=distribute.pc_relevant.none-task-blog-2~default~baidujs_title~default-1.highlightwordscore&spm=1001.2101.3001.4242.2
     *@author: 薛微微
     *@date: 2023-06-21 17:10:40
     */
    FacebookonSuccess(response) {
      console.log("facebook response===", response);
      let _this = this;
      // 登录成功回调
      _this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            var uesr = response.authResponse.accessToken;
            let uinfoData = {
              bind_v: uesr,
              bind_type: 3,
            };
            if (response.status == "connected") {
              _this.loginSubmit(res.data, "Facebook", uinfoData);
            }
          }
        });
    },
    FacebookonFailure(error) {
      console.log("FacebookonFailure====", error);
    },
    /*
     *@description: 谷歌登录 https://developers.google.cn/identity/gsi/web/reference/js-reference?hl=zh-cn 或者 https://blog.csdn.net/weixin_43458965/article/details/125484887
     *@author: 薛微微
     *@date: 2023-06-21 17:10:24
     */
    async handleCredentialResponse(response) {
      console.log("Encoded JWT ID token: " + response);
      this.$generalMethod
        .freezetoken(this.pId, this.appId, this.mdId)
        .then((res) => {
          if (res.code == 200) {
            let uinfoData = {
              bind_v: response.credential,
              bind_type: 2,
            };
            this.loginSubmit(res.data, "Googleplay", uinfoData);
          }
        });
    },
  },
  created: function () {
    this.getPhoneAreaCode();
    this.sendCodeShow();
  },
  mounted() {
    /*
     *@description: 谷歌登录按钮样式初始化
     *@author: 薛微微
     *@date: 2023-06-21 17:10:24
     */
    window.addEventListener("click", () => {
      window.google.accounts.id.initialize({
        // 主要就是填写client_id
        client_id: this.GoogleParams.client_id,
        auto_select: false,
        callback: this.handleCredentialResponse,
      });
      // 设置按钮的样式等
      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        {
          type: "standard",
          theme: "outline",
          size: "medium",
          text: "signin",
          shape: "pill",
          logo_alignment: "left",
          locale: this.$Storage.localStorageGet("lang"),
        }
      );
      // window.google.accounts.id.prompt(); // 也显示一次点击对话框
    });
  },
  watch: {
    page1: {
      handler: "isEmpty1",
      deep: true,
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
